import { ConstraintPurchasableEligibilityFragment } from '@occc/graphql';

import { AwardRestrictionsFormValues } from './award-restrictions.types';

export const transformAwardRestrictionsToFormValues = (
  constraint: ConstraintPurchasableEligibilityFragment,
): AwardRestrictionsFormValues => {
  return {
    isEnabled: true,
    awards: constraint.voucheredOffers,
  };
};
